import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/campaign/Reveal";

const FM_FAQS = [
  {
    q: "What is functional medicine?",
    a: "An approach that looks at your history, lifestyle and test results together to understand what may be contributing to your symptoms, alongside conventional care.",
  },
  {
    q: "Is Dr. Crosson a medical doctor?",
    a: "She is a board-certified physician (DO) with training in family medicine, sports medicine, functional medicine and hormone health.",
  },
  {
    q: "What happens at the first visit?",
    a: "60 minutes: history, review of existing labs, physical exam, InBody assessment, and a discussion of next steps.",
  },
  {
    q: "How much does it cost?",
    a: "$400 for 60 minutes, billed at $100 per 15 minutes of time spent. You\u2019re never billed for time not spent.",
  },
  {
    q: "Do you take insurance?",
    a: "No. We provide a superbill you can submit to your insurer if you choose.",
  },
  {
    q: "Can I use my HSA or FSA?",
    a: "Often you can for eligible medical expenses. Check with your plan administrator; eligibility isn\u2019t guaranteed.",
  },
  {
    q: "Should I bring my previous lab work?",
    a: "Yes. Bring recent results and a list of medications and supplements.",
  },
  {
    q: "Will I need more testing?",
    a: "Possibly. Any testing is discussed with you and based on your evaluation, never assumed.",
  },
  {
    q: "How do I book?",
    a: "Request two preferred times online (optional $25 deposit applied to your visit) or call (484) 544-3345. The office will confirm one with you. Please give 24 hours\u2019 notice to cancel ($100 late-cancel fee).",
  },
];

export const FmFaq = () => (
  <section id="faq" data-testid="fm-faq-section" className="scroll-mt-20 py-16 sm:py-24">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <Reveal>
        <h2 className="font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)]">
          Common questions
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-8">
          {FM_FAQS.map((f, i) => (
            <AccordionItem key={i} value={`fm-faq-${i}`} className="border-[var(--brand-gold-soft)]">
              <AccordionTrigger
                data-testid={`fm-faq-trigger-${i}`}
                className="text-left text-base sm:text-lg font-semibold text-[var(--brand-navy-deep)] hover:no-underline hover:text-[var(--brand-navy)]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-[var(--brand-navy-deep)]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
